import React, { FC } from 'react';
import { Box, IconButton } from '@mui/material';
import { Tag } from '../RadioTag/RadioTag';
import { ReactComponent as AlignmentLeft } from 'assets/images/ImageBlockIcons/alignment-left.svg';
import { ReactComponent as AlignmentCenter } from 'assets/images/ImageBlockIcons/alignment-center.svg';
import { ReactComponent as AlignmentRight } from 'assets/images/ImageBlockIcons/alignment-right.svg';
import { ReactComponent as ActiveAlignmentLeft } from 'assets/images/ImageBlockIcons/active-alignment-left.svg';
import { ReactComponent as ActiveAlignmentCenter } from 'assets/images/ImageBlockIcons/active-alignment-center.svg';
import { ReactComponent as ActiveAlignmentRight } from 'assets/images/ImageBlockIcons/active-alignment-right.svg';
import { ReactComponent as TextAlignmentCenter } from 'assets/images/TextAlignmentIcons/text-alignment-center.svg';
import { ReactComponent as TextAlignmentRight } from 'assets/images/TextAlignmentIcons/text-alignment-right.svg';
import { ReactComponent as TextAlignmentLeft } from 'assets/images/TextAlignmentIcons/text-alignment-left.svg';
import { ReactComponent as ActiveTextAlignmentCenter } from 'assets/images/TextAlignmentIcons/active-text-alignment-center.svg';
import { ReactComponent as ActiveTextAlignmentRight } from 'assets/images/TextAlignmentIcons/active-text-alignment-right.svg';
import { ReactComponent as ActiveTextAlignmentLeft } from 'assets/images/TextAlignmentIcons/active-text-alignment-left.svg';

interface AlignmentRadioGroupProps {
  selected: Tag;
  isTextAlignment?: boolean;
  handleChange: (tag: Tag) => void;
}

enum AlignmentOptions {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

const AlignmentRadioGroup: FC<AlignmentRadioGroupProps> = ({ selected, isTextAlignment = false, handleChange }) => {
  const { value: selectedOption } = selected;
  const alignmentOptions = [
    { option: AlignmentOptions.LEFT, icon: <AlignmentLeft />, activeIcon: <ActiveAlignmentLeft /> },
    { option: AlignmentOptions.CENTER, icon: <AlignmentCenter />, activeIcon: <ActiveAlignmentCenter /> },
    { option: AlignmentOptions.RIGHT, icon: <AlignmentRight />, activeIcon: <ActiveAlignmentRight /> },
  ];
  const alignmentTextOptions = [
    { option: AlignmentOptions.LEFT, icon: <TextAlignmentLeft />, activeIcon: <ActiveTextAlignmentLeft /> },
    { option: AlignmentOptions.CENTER, icon: <TextAlignmentCenter />, activeIcon: <ActiveTextAlignmentCenter /> },
    { option: AlignmentOptions.RIGHT, icon: <TextAlignmentRight />, activeIcon: <ActiveTextAlignmentRight /> },
  ];

  const options = isTextAlignment ? alignmentTextOptions : alignmentOptions;

  const handleClick = (option: string) => {
    handleChange({
      label: option,
      value: option,
    });
  };

  return (
    <Box alignItems='center' display='flex' justifyContent='space-between' gap={2}>
      {options.map(({ option, icon, activeIcon }) => (
        <IconButton key={option} aria-label={option} onClick={() => handleClick(option)} sx={{ padding: '0px' }}>
          {selectedOption === option ? icon : activeIcon}
        </IconButton>
      ))}
    </Box>
  );
};

export default AlignmentRadioGroup;
